
	import Modal from '../Modal.vue';
	import WeightInput from '@/components/WeightInput.vue';
	import ShoeSizePicker from '../ShoeSizePicker.vue';
	import { Observer } from 'mobx-vue';
	import { Component, Vue } from 'vue-property-decorator';
	import FitstationSVG from '@/components/FitstationSVG.vue';
	import NotesButton from '@/components/NotesButton.vue';
	import ShoeSizeModal from '@/components/ShoeSizeModal.vue';
	import DesignInspectionButton from '@/components/DesignInspectionButton.vue';
	import Loading from '@/components/Loading.vue';
	import { observable } from 'mobx';
	import { ShoeSizeUnit, ShoeType } from '@/store/ShoeMeasurements';
	import { WeightType } from '@/store/patientStore';
	import errorMessages from '@/assets/error-messages.json';
	import UtilsStore from '@/store/utilsStore';

	@Observer
	@Component({
		components: {
			WeightInput,
			FitstationSVG,
			NotesButton,
			Modal,
			ShoeSizeModal,
			ShoeSizePicker,
			DesignInspectionButton,
			Loading
		},
		filters: {
			fixedLength(val: string) {
				if (val.length >= 43) {
					return val.slice(0, 40) + '...';
				} else {
					return val;
				}
			}
		}
	})
	export default class PatientModal extends Vue {
		firstName: string = '';
		lastName: string = '';
		patientID: string = '';
		zebraID: string = '';
		assignedDoctor: string = '';
		month: number | '' = '';
		day: number | '' = '';
		year: number | '' = '';
		gender: string | '' = 'unknown';
		weightType: WeightType = 'lbs';
		weight: number | '' = '';

		shoeType: ShoeType = 'standard';
		shoeTypeLR: { L: ShoeType; R: ShoeType } = {
			L: 'standard',
			R: 'standard'
		};
		shoeUnit: ShoeSizeUnit = "US MEN'S";
		shoeUnitL;
		shoeUnitR;

		shoeSize = 11;
		shoeSizeLR = {
			//LR for both, L R for individual
			L: 11,
			R: 11
		};
		private invalid = false;
		private errorMessages: any;
		private settingDOB = false;
		// eslint-disable-next-line no-useless-escape
		private reg: RegExp = /\,|\<|\>|\:|\“|\“|\”|\"|\/|\\|\||\?|\*/;

		close() {
			this.$state.utils.patientModal = false;
		}

		private missingPatientInformation() {
			return Boolean(!this.firstName || !this.lastName || !this.assignedDoctor || !this.$state._patient.patientUIData.weight.value);
		}

		mounted() {
			this.setup();
		}

		private validateInput(e) {
			const res = UtilsStore.unifiedValidatorsForInput(e.data);
			if (res) {
				this.firstName = UtilsStore.removeInvalidCharactersForInput(this.firstName);
				this.lastName = UtilsStore.removeInvalidCharactersForInput(this.lastName);
				this.patientID = UtilsStore.removeInvalidCharactersForInput(this.patientID);
				this.zebraID = UtilsStore.removeInvalidCharactersForInput(this.zebraID);

				this.$state.utils.pushMessage(this.errorMessages.snackbars.invalidCharacters);
			}
		}

		setup() {
			this.errorMessages = errorMessages;
			this.weight = this.$state._patient.patientUIData.weight.value;
			this.weightType = this.$state._patient.patientUIData.weight.type;
			this.shoeSize = this.$state._patient.patientUIData.shoeSizes.shoeSize;
			this.shoeSizeLR = this.$state._patient.patientUIData.shoeSizes.shoeSizeLR;
			this.shoeUnit = this.$state._patient.patientUIData.shoeUnit.shoeUnit;
			this.shoeUnitL = this.$state._patient.patientUIData.shoeUnit.shoeUnitLR.L;
			this.shoeUnitR = this.$state._patient.patientUIData.shoeUnit.shoeUnitLR.R;
			this.shoeType = this.$state._patient.patientUIData.shoeType.shoeType;
			this.shoeTypeLR = this.$state._patient.patientUIData.shoeType.shoeTypeLR;
			this.firstName = this.$state._patient.patientUIData.firstName;
			this.lastName = this.$state._patient.patientUIData.lastName;
			this.patientID = this.$state._patient.patientUIData.patientID;
			this.zebraID = this.$state._patient.patientUIData.zebraID;
			this.month = this.$state._patient.patientUIData.birthDate.month;
			this.day = this.$state._patient.patientUIData.birthDate.day;
			this.year = this.$state._patient.patientUIData.birthDate.year;
			this.assignedDoctor = this.$state._patient.patientUIData.assignedToDoctor;
			this.gender = this.$state._patient.patientUIData.gender;
			this.validate();
		}

		cancel() {
			this.$state._patient.patientUIData.weight.value = this.weight;
			this.$state._patient.patientUIData.weight.type = this.weightType;
			this.$state._patient.patientUIData.shoeSizes.shoeSize = this.shoeSize;
			this.$state._patient.patientUIData.shoeSizes.shoeSizeLR = this.shoeSizeLR;
			this.$state._patient.patientUIData.shoeUnit.shoeUnit = this.shoeUnit;
			this.$state._patient.patientUIData.shoeUnit.shoeUnitLR.R = this.shoeUnitR;
			this.$state._patient.patientUIData.shoeUnit.shoeUnitLR.L = this.shoeUnitL;
			this.$state._patient.patientUIData.shoeType.shoeType = this.shoeType;
			this.$state._patient.patientUIData.shoeType.shoeTypeLR = this.shoeTypeLR;
			this.close();
		}

		async save() {
			if (!this.checkIfValid()) return;
			this.$state._patient.patientUIData.firstName = this.firstName;
			this.$state._patient.patientUIData.lastName = this.lastName;
			this.$state._patient.patientUIData.patientID = this.patientID;
			this.$state._patient.patientUIData.zebraID = this.zebraID;
			this.$state._patient.patientUIData.birthDate.month = this.month;
			this.$state._patient.patientUIData.birthDate.day = this.day;
			this.$state._patient.patientUIData.birthDate.year = this.year;
			this.$state._patient.patientUIData.assignedToDoctor = this.assignedDoctor;
			this.$state._patient.patientUIData.gender = this.gender;

			this.close();
			try {
				this.$state._patient.isDirty = true;
				const id = this.$state._patient.userRecordID;
				const did = this.$state._patient.patientUIData.assignedToDoctor;
				await this.$engine.profile.updateUser(this.$state._patient.userRecordID, {
					firstName: this.$state._patient.patientUIData.firstName,
					lastName: this.$state._patient.patientUIData.lastName,
					gender: this.$state._patient.patientUIData.gender
				});
				await this.$engine.profile.updateUserOwner(id, did);
				await this.$state.leroy.onPrescriptionChanged(); // triggers updateMedicalProfile
				this.$state.prescription.delayedSavePrescription(true);
			} catch (e) {
				this.$state._patient.isDirty = false;
				throw new Error(e);
			}
		}

		private checkSpecialCharacters() {
			// eslint-disable-next-line no-useless-escape
			const fullName = this.firstName + ' ' + this.lastName;
			const patientID = this.patientID;
			const zebraID = this.zebraID;

			if (UtilsStore.unifiedValidatorsForInput(fullName) || UtilsStore.unifiedValidatorsForInput(patientID)) {
				this.$state.utils.pushMessage(this.errorMessages.snackbars.invalidCharacters);
				return false;
			}
			if (UtilsStore.unifiedValidatorsForInput(fullName) || UtilsStore.unifiedValidatorsForInput(zebraID)) {
				this.$state.utils.pushMessage(this.errorMessages.snackbars.invalidCharacters);
				return false;
			}

			return true;
		}

		private checkBOD(): boolean {
			if (this.settingDOB) {
				if (this.day == '' || this.month == '' || this.year == '') {
					return false;
				}
				if (!(Number.isInteger(this.day) && Number.isInteger(this.month) && Number.isInteger(this.year))) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.onlyNumbers);
					return false;
				}
				if (this.month <= 0 || this.month > 12) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.incorrectMonths);
					return false;
				}
				if (this.year < 1900) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.invalidYear);
					return false;
				}
				if (new Date(this.year, this.month - 1, this.day).getTime() > new Date().getTime()) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.futureDate);
					return false;
				}
				if (!(this.day > 0 && this.day <= this.getDays())) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.incorrectDays);
					return false;
				}
			}
			return true;
		}

		private getDays(): number | void {
			if (this.month != '' && this.year != '') {
				const calcMonth = this.month - 1;
				const shorterMonths = [1, 3, 5, 8, 10];
				if (calcMonth === 1) {
					if (this.year % 4 == 0) {
						return 29;
					} else {
						return 28;
					}
				}
				if (shorterMonths.includes(calcMonth)) {
					return 30;
				}
				return 31;
			}
		}

		private checkIfValid() {
			if (!this.checkSpecialCharacters()) {
				return false;
			}
			if (!this.checkBOD()) {
				this.$state.utils.pushMessage(this.errorMessages.snackbars.validBOD);
				this.invalid = true;
				return false;
			}
			this.invalid = false;
			return true;
		}

		private validate() {
			if (this.day != '' || this.month != '' || this.year != '') {
				this.settingDOB = true;
			} else {
				this.settingDOB = false;
			}
		}
	}
